import { useEffect, useRef } from "react"

interface useStuckProps {
  stuckElement?: Element
  scrollContainer?: Element
  enabled?: boolean
}

function useStuck(props: useStuckProps) {
  const dummyRef = useRef<HTMLDivElement>(null)
  const previousTop = useRef<number | null>(null)

  const dummy = <div ref={dummyRef} className="sticky left-0 top-[-2px] h-[0px] w-[1px]" />

  useEffect(() => {
    if (!props.enabled || !props.stuckElement || !dummyRef.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Apenas verifica alterações no eixo vertical (top)
        const currentTop = entry.boundingClientRect.top
        const isStuck = entry.intersectionRatio < 1

        if (previousTop.current !== currentTop) {
          const els = document.querySelectorAll("thead")
          els?.[0]?.classList.toggle("stuck", isStuck)
          // props.stuckElement?.classList.toggle("stuck2", isStuck)
          previousTop.current = currentTop
        }
      },
      { threshold: [1], root: props.scrollContainer },
    )
    let dummy = dummyRef.current
    observer.observe(dummy!)

    return () => {
      if (props.enabled) {
        try {
          observer.unobserve(dummy)
        } catch (e) {
          console.log(e)
        }
        observer.disconnect()
      }
    }
  }, [props.stuckElement, props.enabled, props.scrollContainer])

  return { dummy }
}

export default useStuck
